import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";

type Params = { studioId: string; keyImage: string; imagesFile: File };

export const saveStudioImages = async ({
  studioId,
  keyImage,
  imagesFile,
}: Params) => {
  // References for logo and background images
  const path = `studios/${studioId}/${keyImage}`;
  const imgStorageRef = ref(store, path);

  try {
    await uploadBytes(imgStorageRef, imagesFile);

    // Update Firestore Document
    const docRef = doc(db, "studios", studioId);
    await updateDoc(docRef, {
      [keyImage]: path,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving studio images:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
